module.exports = [{
      plugin: require('../node_modules/gatsby-plugin-material-ui/gatsby-browser.js'),
      options: {"plugins":[],"pathToEmotionCacheProps":""},
    },{
      plugin: require('../node_modules/gatsby-plugin-gdpr-cookies/gatsby-browser.js'),
      options: {"plugins":[],"googleAnalytics":{"trackingId":"G-G22Q1LNTTQ","cookieName":"gatsby-gdpr-google-analytics","anonymize":true,"allowAdFeatures":true},"facebookPixel":{"pixelId":"2614751318863094","cookieName":"gatsby-gdpr-facebook-pixel"},"googleTagManager":{"trackingId":"GTM-KMFFFVC4","cookieName":"gatsby-gdpr-google-tagmanager","dataLayerName":"dataLayer"},"environments":["production","development"]},
    }]
